import React from 'react'
import classNames from 'classnames'

import { IProps } from './index'
import { Shape } from './components/Shape'
import { getHexColorFromName } from '../../utils'

export const ShapeSection: React.FC<IProps> = ({
  shape,
  size = 'tiny',
  color,
  direction = 'upward',
  position = 'inline-with-content',
}) => {
  const shapeSectionClasses = classNames('shape-section', {
    [`shape-section--${direction}`]: direction,
    [`shape-section--${position}`]: position,
  })

  const shapeClasses = classNames('shape-section__shape', {
    [`shape-section__shape--${shape}`]: shape,
  })

  const shapeColor = getHexColorFromName(color)

  return (
    <>
      <section className={shapeSectionClasses} data-testid="shape-section">
        <Shape className={shapeClasses} shape={shape} size={size} color={shapeColor} />
      </section>

      <style jsx>
        {`
          .shape-section {
            width: 100%;

            &--inline-with-content {
              position: relative;
            }

            &--behind-content {
              position: absolute;
              z-index: -1;
            }

            :global(&__shape) {
              width: 100%;
              height: auto;
              display: block; // Removes blank space below SVG.
            }

            &--upward {
              &.shape-section--behind-content {
                transform: translateY(-100%);
              }

              :global(.shape-section__shape) {
                bottom: 100%;
              }

              // Pseudo element required to patch the white line below the SVG
              // created by Chromium’s rendering problem.
              &::after {
                content: '';
                position: absolute;
                top: calc(100% - 1px);
                right: 0;
                bottom: -1px;
                left: 0;
                background-color: ${shapeColor};
              }
            }

            &--downward {
              :global(.shape-section__shape) {
                transform: rotateX(180deg);
              }
            }
          }
        `}
      </style>
    </>
  )
}
